import { useState } from "react";
import Paginacion from "../../globales/Paginacion";
import PropTypes from 'prop-types';

/**
 * Este componente recibe una serie de propiedades que son necesarios para renderizar la tabla de estudiantes en la pantalla de editar club. Además, hace uso del componente global Paginacion.
 * @returns EditarListaEstudiantes
 */
const EditarListaEstudiantes = (props) => {
  const { datosEstudiantes, textosTabla, eliminarEstudianteIndividual, botonEliminar } = props;
  const { codigo, curso, nombres_apellidos, sede, sin_codigo, sin_estudiantes } = textosTabla;
  const [datosDivididos, setDatosDivididos] = useState([]);

  /*Esta función es para el componente de paginación y devuelve la cantidad de datos que se deben mostrar */
  const ActualizarDatosDivididos = (value) => setDatosDivididos(value)

  return (
    <>
    <div role="table" aria-label="Estudiantes seleccionados" aria-rowcount={datosDivididos.length}>
      <div role="rowgroup" className="encabezadoTabla">
        <p role="columnheader" aria-sort="none" className="col-span-2">{codigo}</p>
        <p role="columnheader" aria-sort="none" className="xl:col-span-3">{nombres_apellidos}</p>
        <p role="columnheader" aria-sort="none" className=" xl:col-span-3">{sede}</p>
        <p role="columnheader" aria-sort="none" className=" xl:col-span-3">{curso}</p>
        <p role="columnheader" aria-sort="none" className="col-span-1"></p>
      </div>
      {datosDivididos.length === 0 ?
        <div className="filaTabla xl:grid-cols-12" role="rowgroup">
          <div className=" center col-span-12" role="row">
            <span className="icon-alerta text-18 red-inv-var2--color mr-3"></span>
            <p className="raleway-700  red-inv-var2--color text-16"> {sin_estudiantes}</p>
          </div>
        </div>
        :
        datosDivididos.map((dato, index) => {
          return (
            <div role="row" aria-rowindex={index + 1} key={`campo${index}`} className="filaTabla">
              <div className="fila-10-sm5-md3-lg6 xl:col-span-2">
                <span className="q7-14-negro26  xl:hidden">{codigo}</span>
                <p role="cell" className={`${!!dato.codigo ? 'r7-morado text-13 ' : 'r7-13-rojo'} break-words`}>{!!dato.codigo ? dato.codigo : sin_codigo}</p>
              </div>
              <div className="fila-10-sm5-md3-lg6 xl:col-span-3">
                <span className="q7-14-negro26  xl:hidden">{nombres_apellidos}</span>
                <p role="cell"  className="r5-13-negro26 break-words">{dato.nombre}</p>
              </div>
              <div className="fila-10-sm5-md3-lg6 xl:col-span-3 overflow-auto">
                <span  className="q7-14-negro26  xl:hidden">{sede}</span>
                <p role="cell" className="r5-13-negro26 break-words">{!!dato.sede ? dato.sede : dato.nombreSede}</p>
              </div>
              <div className="fila-10-sm5-md3-lg6 xl:col-span-3 overflow-auto">
                <span className="q7-14-negro26  xl:hidden">{curso}</span>
                <p role="cell"  className="r5-13-negro26 break-words">{!!dato.curso ? dato.curso : dato.nombreCurso}</p>
              </div>
              <div className="col-span-12 xl:col-span-1">
                <div className="md:alineado-izquierda-center">
                  <button
                    className="focusable-primary boton-justo boton-rojo boton_hover_morado center w-full md:w-auto md:px-10 xl:p-2 mb-3 md:mb-0"
                    onClick={() => {
                      eliminarEstudianteIndividual({ idEstudiante: dato.id })
                    }}
                  >
                    <p className="xl:hidden">{botonEliminar} </p><span role="cell" aria-label="Eliminar estudiante" className="pl-3 xl:pl-0 icon-basura"></span>
                  </button>
                </div>

              </div>
            </div>
          )
        })
      }
</div>
      <div className={`alineado-izquierda xl:mt-3`}>
        <Paginacion datos={datosEstudiantes} datosDivididos={ActualizarDatosDivididos} />
      </div>
    </>
  )
}
export default EditarListaEstudiantes;

EditarListaEstudiantes.propTypes = {
  /**
   *  Es un array de objetos que almacena los datos de los estudaintes asignados al club. 
   */
  datosEstudiantes: PropTypes.array,
  /**
  *  Es un objeto que trae los textos del encabezado de la tabla. Este cambia según el idioma activo.
  */
  textosTabla: PropTypes.object.isRequired,
  /**
     * Es una función que se encarga de remover los estudiantes que se desean asignar al Club.
     * @type{Function({ idEstudiante: string }):void}
     */
  eliminarEstudianteIndividual: PropTypes.func,
  /**
   * string que corresponde al texto del boton eliminar
   */
  botonEliminar: PropTypes.string
}